module.exports = __webpack_public_path__ + "img/app-2.faee15e7.png";